import React, { useEffect } from 'react'; 
import { connect } from 'react-redux'; 
import { useNavigate } from 'react-router-dom';
import MagnifyGlass from '../../../Images/NewUI/magnify.png';
import Heading from '../Common/MainHeading';
import { HEADING_EMPLOYMENT } from '../Common/constant';
import { getDocumentStatus ,professioanlWebView } from "../../../Redux/Manual_Kyc_Details/action";
import { withRouter } from "../../../hooks/withRouter";

const EmploymentDetail = (props) => {
const navigate = useNavigate(); 

const handleprofessioanlWebView= () =>{
  
  let token = props.token || localStorage.getItem("gpay_token");
  props.professioanlWebView(token,true)
  
    .then((res) => {
      
      // console.log(res,"res of web view url");
      setTimeout (()=>{
        window.open(res.data.url, '_blank');
      },100)
      
      // window.open(res.data.url);
    })
    .catch((err) => {
      
      if (err.response?.status === 401) {
      window.location.href = "/";
        localStorage.removeItem("gpay_token");
      }
      // alert(err)
      let error = err?.response?.data?.error;
      ToastMsg(error, "error");
      // console.log(error);
    });
}

const handleContinueBtn = () =>{
  const token = localStorage.getItem("gpay_token");
    
  props.getDocumentStatus(token).then((res) => {
    const data = res?.data[0]; 
    if (data.professional_details_verified === "VERIFIED") {
      
      if (data.kyc_verified === "VERIFIED") {
        
        window.location.href = "/key-statements";
      } else {
        navigate("/manual_verify?keyfrom=apply_now")
      }
    } else {
      
      handleprofessioanlWebView()
    }
  }).catch((error) => {
    
    console.log(error);
  });
}

const handleRecallGetstatusApi = () => {
  let count = 0;
  const intervalId = setInterval(() => {
    if (count >= 1000) {
      clearInterval(intervalId); 
      return;
    }
    
    const token = localStorage.getItem("gpay_token");
    props.getDocumentStatus(token).then((res) => {
      const data = res?.data[0];

      if (data.professional_details_verified === "VERIFIED") {
        if (data.kyc_verified === "VERIFIED") {
          window.location.href = "/key-statements";
        } else {
          
          navigate("/manual_verify?keyfrom=apply_now")
        }
        clearInterval(intervalId);
      }
    }).catch((error) => {
      console.log(error);
    });

    count++;
  }, 3000); 
};
  useEffect(() => { 
    const token = localStorage.getItem("gpay_token");
    props.getDocumentStatus(token).then((res) => {
      handleRecallGetstatusApi()
      const data = res?.data[0]; 

      if (data.professional_details_verified === "VERIFIED") {
        
        if (data.kyc_verified === "VERIFIED") {
          
          window.location.href = "/key-statements";
        } else {
          navigate("/manual_verify?keyfrom=apply_now")
        }
      } else {
        
        handleprofessioanlWebView()
      }
    }).catch((error) => {
      
      console.log(error);
    });
  }, []); 

  return (
    <>
    <div className='toolbarRespo'>
      <div className='shadowlinepurebottom '>
        <Heading headingText={HEADING_EMPLOYMENT} />
      </div>
      </div>
      <div className="container">
        <div className="pb-2">
          <div className="padding"></div>
          <div className="wrapper-content mb-5">
            <div className="px-4 pb-3 pt-1 w-100 text-center mx-auto">
              <div className="styled h-100 d-flex flex-column mb-5">
                <div>
                  <img
                    src={MagnifyGlass}
                    className="SpinningRocket"
                    style={{ width: 230, height: 297 }}
                    alt="PaymeIndia"
                  />
                </div>
                <p className="employmentdetail">
                  Employment details could not be verified. Please try again.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center bottom_zero">
          <button
            onClick={handleContinueBtn}
            className="bg-orange text-white newbtnDesign uhuhbtn py-6"
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};

export default withRouter(connect(mapStateToProps, { getDocumentStatus, professioanlWebView })(EmploymentDetail));
